<template>
  <Modal :is-open="isOpen" :closeable="false">
    <div>{{ translation.itemList.useItemSuccess }}!</div>
    <template #footer>
      <button
        type="button"
        class="btn btn-secondary"
        @click="$emit('update:is-open', false)"
      >
        {{ translation.general.okay }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../Modal/Modal.vue";
import { translation } from "@/utils/translations";

export default {
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:is-open"],
  setup() {
    return {
      translation,
    };
  },
};
</script>
